import { SpuSaleInfoType, SkuInfoType } from "../../../types";

import AdjoinMatrix from "./AdjoinMatrix";
import { AdjoinType } from "./types";

/**
 * 领接矩阵选择sku
 * 参考：https://cloud.tencent.com/developer/article/1658305
 */
export default class SpecAdjoinMatrix extends AdjoinMatrix {
  specList: Array<SpuSaleInfoType>;

  specCombinationList: Array<SkuInfoType>;

  constructor(specList: Array<SpuSaleInfoType>, specCombinationList: Array<SkuInfoType>) {
    super(specList.reduce((total: AdjoinType, current) => [...total, ...current.values], []));
    this.specList = specList;
    this.specCombinationList = specCombinationList;
    // 根据可选规格列表矩阵创建
    this.initSpec();
    // 同级顶点创建
    this.initSameLevel();
  }

  /**
   * 根据可选规格组合填写邻接矩阵的值
   */
  initSpec(): void {
    this.specCombinationList.forEach((item) => this.fillInSpec(Object.values(item.properties)));
  }

  // 填写同级点
  initSameLevel(): void {
    // 获得初始所有可选项
    const specsOption = this.getCollection(this.vertex);
    this.specList.forEach((item) => {
      const params: AdjoinType = item.values.filter((value) => specsOption.includes(value));
      // 获取同级别顶点
      // item.list.forEach((value) => {
      //   if (specsOption.includes(value)) params.push(value);
      // });
      // 同级点位创建
      this.fillInSpec(params);
    });
  }

  /*
   * @params
   * 传入顶点数组，查询出可选规格
   */
  getSpecsOptions(params: AdjoinType): AdjoinType {
    let specOptionCanChoose: AdjoinType = [];
    if (params.some(Boolean)) {
      // 获取可选项（交集）
      specOptionCanChoose = this.getUnions(params.filter(Boolean));
    } else {
      // 所有可选项
      specOptionCanChoose = this.getCollection(this.vertex);
    }
    return specOptionCanChoose;
  }

  /*
   * @params
   * 填写邻接矩阵的值
   */
  fillInSpec(params: AdjoinType): void {
    params.forEach((param) => this.setAdjoinVertexes(param, params));
  }
}
